var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 2.02637H4.99992C4.55789 2.02637 4.13397 2.20196 3.82141 2.51452C3.50885 2.82708 3.33325 3.25101 3.33325 3.69303V17.0264C3.33325 17.4684 3.50885 17.8923 3.82141 18.2049C4.13397 18.5174 4.55789 18.693 4.99992 18.693H14.9999C15.4419 18.693 15.8659 18.5174 16.1784 18.2049C16.491 17.8923 16.6666 17.4684 16.6666 17.0264V7.02637L11.6666 2.02637ZM13.1666 17.0264H11.6666L9.99992 14.193L8.33325 17.0264H6.83325L9.24992 13.2764L6.83325 9.52637H8.33325L9.99992 12.3597L11.6666 9.52637H13.1666L10.7499 13.2764L13.1666 17.0264ZM10.8333 7.8597V3.27637L15.4166 7.8597H10.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.34cc02b0e7ba172f002242e665a32832.svg";
export { ForwardRef as ReactComponent };